import { ComponentType } from 'react';

/**
 * Widget libs (e.g. call-intel-core inside a demo panel) cannot import the task-center feature lib. The feature
 * registers its demo-panel component here so `openTaskWithTaskId` can open it inside the demo panel stack.
 */
let demoTaskPanelComponent: ComponentType | null = null;

export const setDemoTaskPanelComponent = (component: ComponentType | null) => {
  demoTaskPanelComponent = component;
};

export const getDemoTaskPanelComponent = () => demoTaskPanelComponent;
